import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { LucideNavIcons } from '../../../icons/lucideNavIcons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

import scss from '../project-name-header/ProjectNameHeader.module.scss';

const SettingsHeader = () => {
  const { t } = useTranslation('header');

  return (
    <ProjectNameHeader
      icon={LucideNavIcons.Settings}
      selector={() => null}
      defaultName={t('settings')}
      iconProps={{ disableCommonStyles: true, className: scss.iconStroke }}
    />
  );
};

export default memo(SettingsHeader);
